export default "__VITE_ASSET__xegp$974__"